export enum PosthogFeatureFlag {
  RESIDENTIAL_STATUS_ENABLED = 'residential-status-enabled',
  STRIDE_DESIGN_SYSTEM = 'stride-design-system',
  /** Not configured in PostHog. Read by tests only. */
  TEST_ONLY_FLAG = 'test_only_flag',
}
